/** `0x021a…2da1`: the first four and last four hex digits. */
export function shortAddress(address: string): string {
  return address.length < 12 ? address : `${address.slice(0, 6)}…${address.slice(-4)}`;
}
